import { toPng } from 'html-to-image'

export const downloadChart = async (node: HTMLElement, fileName: string) => {
  try {
    const dataUrl = await toPng(node, {
      backgroundColor: '#FFFFFF',
      pixelRatio: 2,
      quality: 1.0,
      includeQueryParams: true,
      filter: (node) => {
        // DOM element might be HTMLElement or SVGElement
        const el = node as HTMLElement | SVGElement
        let classNameStr = ''

        if ('className' in el) {
          if (typeof el.className === 'string') {
            classNameStr = el.className
          } else if ('baseVal' in el.className) {
            classNameStr = el.className.baseVal
          }
        }

        return (
          // !classNameStr.includes('ant-btn') &&
          !classNameStr.includes('absolute') && !classNameStr.includes('omit-from-download')
        )
      }
    })

    const link = document.createElement('a')
    link.download = fileName
    link.href = dataUrl
    link.click()
  } catch (error) {
    console.error('Error downloading chart:', error)
  }
}
